import React, { useEffect, useState } from "react";
import { Swiper, Modal } from "antd-mobile";
import "./css/InviteFriends.css";
import InviteAlert from "./InviteAlert";
import general from "../../general";
import Dialog from "../../lib/Dialog";
import { NavLink } from "../../lib/Navigation";

export default function InviteFriends(props) {
  const [data, setData] = useState({});
  const [rebate_rules, setRebateRules] = useState([]);
  const [invite_users, setInviteUsers] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [init, setInit] = useState(false);

  const inviteFriendIndex = () => {
    Dialog.loading();
    general.axios
      .post("/inviteFriendIndex")
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        const { status, data } = res.data;
        if (status.succeed) {
          setData(data);
          setInit(true);
          setRebateRules(data.rebate_rules);
          setInviteUsers(data.invite_users);
        } else {
          Dialog.error(status.error_desc);
        }
      });
  };

  useEffect(() => {
    if (props.active && !init) {
      inviteFriendIndex();
      props.setOperate(
        <NavLink
          user={true}
          to="/invite/record"
          className="invite-index-record"
        >
          邀请明细
        </NavLink>
      );
    }
  }, [props.active, init]);

  const usersDiv = invite_users.map((user, index) => (
    <Swiper.Item key={index}>
      <div
        style={{
          fontSize: 13,
          backgroundImage: "linear-gradient(to right, #fff, transparent)",
          borderRadius: 12,
          padding: 2.5,
          display: "flex",
          alignItems: "center",
        }}
      >
        <img
          src={user.avator}
          alt=""
          width={18}
          height={18}
          style={{ borderRadius: "50%" }}
        />
        <span style={{ color: "#FF9C00", paddingLeft: 5 }}>
          {user.nick_name}
        </span>
        <span style={{ color: "#480B00", paddingLeft: 5 }}>已赚到</span>
        <span style={{ color: "#FF9C00" }}>{user.amount}元金币</span>
      </div>
    </Swiper.Item>
  ));

  const ruleDiv = () => {
    return (
      <div>
        <div className="rule">
          {rebate_rules.map((item, index) => (
            <div key={index} className="item">
              <div
                className="content"
                style={{
                  backgroundImage: "url(resources/251222/item-bg.png)",
                  backgroundSize: "100% 100%",
                }}
              >
                <div className="title">{item.text}</div>
                <div className="btn">
                  <img src={item.button} alt="" />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="desc-img">
          <div className="desc">
            <p dangerouslySetInnerHTML={{ __html: data?.rule_tips?.replace(/\n/g, "<br/>") }}></p>
          </div>

          <div style={{ paddingTop: "10px", paddingBottom: "20px" }}>
            <img src={data?.free_claim_img} alt="" />
          </div>
        </div>

        <div className="invite-btn" onClick={handleInvete}>
          <img src="resources/251222/invite-btn.png" alt="" />
        </div>
      </div>
    );
  };

  const handleInvete = () => {
    Modal.show({
      content: (
        <InviteAlert data={data} onClose={() => Modal.clear()}></InviteAlert>
      ),
      bodyClassName: "invite-alert-modal",
      maskClassName: "invite-alert-mask",
      className: "invite-alert-index",
      getContainer: document.getElementById("root"),
      bodyStyle: {
        padding: 0,
      },
    });
  };

  const handleReceive = () => {
    Dialog.loading();
    general.axios
      .post("/claimEarnings")
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        const { status, data } = res.data;
        if (status.succeed) {
          Dialog.success("提取成功");
          setData({ ...data, available_earnings: 0 });
        } else {
          Dialog.error(status.error_desc);
        }
      });
  };

  const handleReceiveAlert = () => {
    if (parseInt(data?.available_earnings) <= 0) {
      Dialog.error("暂无可提取收益");
      return;
    }
    Modal.show({
      bodyStyle: {
        padding: "20px 20px 10px",
        borderRadius: "18px",
      },
      maskClassName: "select-account-mask",
      bodyClassName: "select-account-body",
      getContainer: document.getElementById("root"),
      title: (
        <div
          style={{
            fontSize: "17px",
            fontWeight: "500",
            color: "#282828",
            marginBottom: "10px",
          }}
        >
          是否提取
        </div>
      ),
      content: (
        <div style={{ fontSize: "13px", color: "#666", textAlign: "center" }}>
          <div>
            可提现
            <span style={{ color: "#E93925" }}>{data?.available_earnings}</span>
            个金币
          </div>
        </div>
      ),
      closeOnAction: true,
      actions: [
        {
          key: "done",
          text: "立即提取",
          primary: true,
          className: "done",
          style: {
            backgroundColor: "var(--MainColor)",
            border: "none",
            width: "90%",
            margin: "0 auto",
            borderRadius: "24px",
            fontWeight: 500,
            fontSize: "15px",
          },
          onClick: () => {
            Modal.clear();
            setTimeout(() => {
              handleReceive();
            }, 400);
          },
        },
        {
          key: "cancel",
          text: "取消",
          className: "cancel",
          style: {
            color: "#999",
            fontSize: "13px",
            padding: "10px",
          },
          onClick: () => {
            Modal.clear();
          },
        },
      ],
    });
  };

  const incomeDiv = () => {
    return (
      <div className="income">
        <div
          className="container"
          style={{
            backgroundImage: "url(resources/251222/item-bg.png)",
            backgroundSize: "100% 100%",
          }}
        >
          <div className="flex-item">
            <div className="title">可领取收益（个）</div>
            <NavLink to="/receive/record" className="record">
              领取记录{">"}
            </NavLink>
          </div>
          <div className="flex-item">
            <div className="value">{data?.available_earnings}</div>
            <div className="income-btn" onClick={handleReceiveAlert}>
              <img src="resources/251222/receive-btn.png" alt="" />
            </div>
          </div>
        </div>

        <div className="share">
          <div>
            <span className="default">分享到</span>
            <span className="highlight">3个以上微信/QQ群</span>
          </div>
          <div>
            <span className="default">成功几率可提高</span>
            <span className="highlight">200%</span>
          </div>
        </div>

        <div className="btn" onClick={handleInvete}>
          <img src="resources/251222/income-btn.png" alt="" />
        </div>
      </div>
    );
  };

  return (
    <div className="invite-friends-page">
      <div className="invite-friends-container">
        <img src="resources/251222/bg.png" alt="" />

        <div className="content">
          <div className="header">
            <div className="banner">
              <Swiper
                loop={true}
                autoplay={{
                  delay: 2000,
                }}
                direction="vertical"
                style={{ "--height": "24px" }}
                indicator={() => null}
              >
                {usersDiv}
              </Swiper>
            </div>
            <div className="right">
              <div className="desc">10金币=1元充值</div>
              <div className="desc">金币可提取到账户内用于充值</div>
            </div>
          </div>

          <div
            className="tabs"
            style={{
              backgroundImage:
                tabIndex == 0
                  ? "url(resources/251222/rule.png)"
                  : "url(resources/251222/income.png)",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundColor: "#C2EEFF",
              borderTopLeftRadius: 13,
              borderTopRightRadius: 13,
            }}
          >
            {[0, 1].map((item, index) => (
              <div
                className="item"
                key={index}
                onClick={() => setTabIndex(index)}
              ></div>
            ))}
          </div>

          <div className="list">{tabIndex == 0 ? ruleDiv() : incomeDiv()}</div>
        </div>
      </div>
    </div>
  );
}
